import alt from '../../alt';
import moment from 'moment';
import HostPortalActions from './HostPortalActions';
import AddressModel from '../../Addresses/AddressModel';
import 'idempotent-babel-polyfill';

class HostPortalStore {
	constructor() {
		this.state = {
			NewPartyTitle: '',
			NewPartyDate: moment().format('L'),
			MyPartiesList: [],
			EventTypes: [],
			DisplayThemeList: [],
			TemplateCategories: [],
			selectedTheme: "",
			isVirtual: true,
			maxEventDays: 0,
			userCulture: window.jenkon.culture,
			startTime: '',
			endTime: '',
			NewPartyLocation: new AddressModel(),
			selectedEventDetails: null,
			selectedTab: 'details',
			showRequestSuccess: false,
			showCongrats_HostTips: false,
			AddGuest_GuestName: "",
			AddGuest_GuestEmailAddress: "",
			validGuestEmail: true,
			validGuestEmail_edit: true,
			selectedStatus: "",
			guestStatusList: [],
			currentInvitePreview: '',
			numberofInvitesSent: 0,
			hasVirtual: true,
			timeZoneList: [],
			timeZone: '',
			eventTotals: null,
			hostRewardsSummaries: null,
		};

		this.bindListeners({
			getTimeZones: HostPortalActions.GET_TIME_ZONES_SUCCESS,
			hostPartyListChanged: HostPortalActions.GET_HOST_EVENT_SUCCESS,
			changeField: HostPortalActions.CHANGE_FIELD,
			setEventTypes: HostPortalActions.EVENT_TYPES_SUCCESS,
			setVirtual: HostPortalActions.SET_VIRTUAL,
			setTheme: HostPortalActions.CHANGE_THEME,
			virtualEventSuccess: HostPortalActions.CREATE_VIRTUAL_EVENT_SUCCESS,
			virtualEventFailure: HostPortalActions.CREATE_VIRTUAL_EVENT_FAILURE,
			physicalEventSuccess: HostPortalActions.PHYSICAL_EVENT_SUCCESS,
			physicalEventFailure: HostPortalActions.PHYSICAL_EVENT_FAILURE,
			getEventSuccess: HostPortalActions.GET_EVENT_SUCCESS,
			getEventFailure: HostPortalActions.GET_EVENT_FAILURE,
			getHostEventDetailSuccess: HostPortalActions.GET_HOST_EVENT_DETAIL_SUCCESS,
			getHostEventDetailFailure: HostPortalActions.GET_HOST_EVENT_DETAIL_FAILURE,
			setTab: HostPortalActions.SET_TAB,
			setNewPartyAddress: HostPortalActions.SET_NEW_PARTY_ADDRESS,
            resetSuccessState: HostPortalActions.RESET_SUCCESS_STATE,
			addGuestSuccess: HostPortalActions.ADD_GUEST_SUCCESS,
			addGuestFailure: HostPortalActions.ADD_GUEST_FAILURE,
            changeIsPublicFlag: HostPortalActions.SET_PARTY_VISIBILITY_SUCCESS,
            saveEventChanges: HostPortalActions.SAVE_PARTY_CHANGES_SUCCESS,
			partyCreatedTab: HostPortalActions.PARTY_CREATED_TAB,
			getGuestStatusesSuccess: HostPortalActions.GET_GUEST_STATUSES_SUCCESS,
			getGuestStatusesFailure: HostPortalActions.GET_GUEST_STATUSES_FAILURE,
			validateGuestSuccess: HostPortalActions.VALIDATE_GUEST_SUCCESS,
			validateGuestFailure: HostPortalActions.VALIDATE_GUEST_FAILURE,
			updateGuestSuccess: HostPortalActions.UPDATE_GUEST_SUCCESS,
			updateGuestFailure: HostPortalActions.UPDATE_GUEST_FAILURE,
			deleteGuestSuccess: HostPortalActions.DELETE_GUEST_SUCCESS,
			deleteGuestFailure: HostPortalActions.DELETE_GUEST_FAILURE,
			validateGuestEditSuccess: HostPortalActions.VALIDATE_GUEST_EDIT_SUCCESS,
			validateGuestEditFailure: HostPortalActions.VALIDATE_GUEST_EDIT_FAILURE,
			setSelectedStatus: HostPortalActions.SET_SELECTED_STATUS,
			setSelectedParty: HostPortalActions.SET_SELECTED_PARTY,
			resetValidGuestEmail: HostPortalActions.RESET_VALID_GUEST_EMAIL,
			resetValidGuestEmailEdit: HostPortalActions.RESET_VALID_GUEST_EMAIL_EDIT,
			addInvitePreview: HostPortalActions.GET_TEMPLATE_RESOURCE_SUCCESS,
			setNewInviteTemplate: HostPortalActions.SET_NEW_INVITE_TEMPLATE_SUCCESS,
			pendingInvitesSent: HostPortalActions.SEND_PENDING_INVITES_SUCCESS,
			remindersSent: HostPortalActions.SEND_REMINDERS_SUCCESS,
			sendReminderSuccess: HostPortalActions.SEND_REMINDER_SUCCESS,
			guestInviteSent: HostPortalActions.SEND_GUEST_INVITE_SUCCESS,
			clearFormValues: HostPortalActions.CLEAR_FORM_VALUES,
		});
	}

	guestInviteSent(responseData) {
		this.setState({
			selectedEventDetails: responseData.eventData.event
		});
		let resentmessage = window.jenkon.resources["PWS.MyAccount.GuestsTabResendConfirmation"].replace("{0}", responseData.eventData.sendResults[0].key);
		let sentMessage = window.jenkon.resources["PWS.MyAccount.GuestsTabInviteSentConfirmation"].replace("{0}", responseData.eventData.sendResults[0].key);
		let invitesMessage = window.jenkon.resources['PWS.MyAccount.GuestsTabInviteAllConfirmation'].replace('{0}', '0');
		if(responseData.eventData.sendResults[0].value)
			alert(responseData.isResend ? resentmessage : sentMessage);
		else
			alert(invitesMessage);
	}

	remindersSent(responseData) {
		this.setState({
			selectedEventDetails: responseData.event
		});
		let reminderCount = responseData.sendResults.filter(r => r.value);

		alert(`${window.jenkon.resources["PWS.MyAccount.GuestsTabAllRemindersConfirmation"].replace('{0}', reminderCount.length)}`);
	}

	sendReminderSuccess(responseData) {
		this.setState({
			selectedEventDetails: responseData.event,
		});
		let remindermessage = window.jenkon.resources["PWS.MyAccount.GuestsTabReminderConfirmation"].replace("{0}", responseData.sendResults[0].key);
		let noneSent = window.jenkon.resources["PWS.MyAccount.GuestsTabAllRemindersConfirmation"].replace('{0}', '0');
		if(responseData.sendResults[0].value)
			alert(remindermessage);
		else
			alert(noneSent);
	}

	pendingInvitesSent(eventData) {
		this.setState({
			selectedEventDetails: eventData.event
		});
		let inviteCount = eventData.sendResults.filter(r => r.value);
		let invitesMessage = window.jenkon.resources['PWS.MyAccount.GuestsTabInviteAllConfirmation'].replace('{0}', inviteCount.length);
		alert(invitesMessage);
	}

	addInvitePreview(previewHtml) {
		this.setState({
			currentInvitePreview: previewHtml
		});
	}

	setNewInviteTemplate(eventData) {
		this.setState({
			selectedEventDetails: eventData
		});
	}

	setSelectedParty(party) {
		this.setState({
            selectedEventDetails: party,
        });
	}

    saveEventChanges(eventData) {
        this.setState({
            selectedEventDetails: eventData,
        });
    }

    changeIsPublicFlag() {
        let currentEventDetails = this.state.selectedEventDetails;
        currentEventDetails.isPublic = !currentEventDetails.isPublic;
        this.setState({
            selectedEventDetails: currentEventDetails
        });
    }

	getTimeZones(data) {
		this.setState({
			timeZoneList: data
		});
	}

    resetSuccessState() {
        this.setState({
            showRequestSuccess: false,
        });
    }

    setNewPartyAddress(address) {
        this.setState({
            NewPartyLocation: address
        });
    }

	updateGuestSuccess(eventData) {
		this.setState({
			selectedEventDetails: eventData
		})
	}

	updateGuestFailure(eventData) {
		return;
	}

	deleteGuestSuccess(eventData) {
		this.setState({
			selectedEventDetails: eventData
		})
	}

	deleteGuestFailure(eventData) {
		return;
	}

	hostPartyListChanged(parties) {
		                       
		parties = parties.sort((a, b) => {
			return parseInt(b.code) - parseInt(a.code);
		});

		this.setState({
			MyPartiesList: parties,
			selectedEventDetails: null,
			eventCode: null,
			selectedTab: 'details',
			showCongrats_HostTips: false
		})
	}

	getGuestStatusesSuccess(statuses) {
		this.setState({
			guestStatusList: statuses
		});
	}

	getGuestStatusesFailure() {
		return true;
	}

	virtualEventSuccess(data) {
		this.setState({
			showRequestSuccess: false,
			NewPartyTitle: '',
			NewPartyDate: moment().format('L'),
			startTime: '',
			endTime: '',
			NewPartyLocation: new AddressModel()
		});
	}

	virtualEventFailure(data) {
		console.log(data)
	}

	physicalEventSuccess(response) {
        this.setState({
			showRequestSuccess: true,
			NewPartyTitle: '',
			NewPartyDate: moment().format('L'),
			startTime: '',
			endTime: '',
			NewPartyLocation: new AddressModel()
		});
	}

	physicalEventFailure(data) {
		console.log(data)
	}

	getEventSuccess(data) {
       //console.log("getEventSuccess", data);
		this.setState({
			selectedEventDetails: data
		})
	}

	getEventFailure(data) {
		console.log(data)
	}

    getHostEventDetailSuccess(data) {
        //console.log("getEventSuccess", data);
        this.setState({
            selectedEventDetails: data
        })
    }

    getHostEventDetailFailure(data) {
        console.log(data)
    }

	changeField(diff) {
		this.setState(diff);
	}

	clearFormValues() {
		this.setState({
			NewPartyTitle: '',
			startTime: '',
			endTime: '',
			selectedTheme: ""
		})
	}

	setTheme(diff) {
		let virtual = this.state.EventTypes.filter(t => t.code === diff.selectedTheme);
		this.setState({
			selectedTheme: diff.selectedTheme,
	        maxEventDays: this.state.isVirtual ? (virtual && virtual.length > 0 ? virtual[0].maxEventDays : 0) : 0
		});
	}

	setTab(tab) {
		this.setState({
			selectedTab: tab
		});
	}

	partyCreatedTab() {
		this.setState({
			showRequestSuccess: false,
			NewPartyTitle: '',
			NewPartyDate: moment().format('L'),
			startTime: '',
			endTime: '',
			NewPartyLocation: new AddressModel(),
			selectedTab: 'tips',
			showCongrats_HostTips: true
		});
	}

	addGuestSuccess(data) {
		this.setState({
			selectedEventDetails: data,
			AddGuest_GuestName: "",
			AddGuest_GuestEmailAddress: ""
		});
	}

	resetValidGuestEmail() {
		this.setState({
			validGuestEmail: true
		})
	}

	resetValidGuestEmailEdit() {
		this.setState({
			validGuestEmail_edit: true
		})
	}

	validateGuestSuccess(data) {
		this.setState({
			validGuestEmail: data
		})
	}

	validateGuestFailure(data) {
		this.setState({
			validGuestEmail: !this.state.isVirtual ? true : false
		})
	}

	validateGuestEditSuccess(data) {
		this.setState({
			validGuestEmail_edit: data
		})
	}

	validateGuestEditFailure(data) {
		this.setState({
			validGuestEmail_edit: !this.state.isVirtual ? true : false
		})
	}

	setSelectedStatus(selectedStatus) {
		this.setState({
			selectedStatus
		})
	}

	addGuestFailure(data) {
		return false
	}

	setEventTypes(types){
		let virtual = types.filter(t => t.isVirtual);
		let physical = types.filter(t => !t.isVirtual);
		let maxEventDays = 0;
		if (virtual.length === 0) {
			this.setState({
				hasVirtual: false,
				isVirtual: false,
			});
		}
		if (this.state.isVirtual) {
			maxEventDays = virtual.length !== 0 ? virtual[0].maxEventDays : 0;
		}

		this.setState({
			EventTypes: types,
			DisplayThemeList: this.state.isVirtual ? virtual : physical,
			selectedTheme: this.state.isVirtual ? (virtual && virtual.length > 0 ? virtual[0].code : "") : (physical && physical.length > 0 ? physical[0].code : ""),
			maxEventDays: maxEventDays
		});
	}

	setVirtual(isVirtual) {
		let virtual = this.state.EventTypes.filter(t => t.isVirtual);
		let physical = this.state.EventTypes.filter(t => !t.isVirtual);
		this.setState({
			isVirtual,
			DisplayThemeList: isVirtual ? virtual : physical,
			selectedTheme: isVirtual ? (virtual && virtual.length > 0 ? virtual[0].code : "") : (physical && physical.length > 0 ? physical[0].code : ""),
			maxEventDays: isVirtual ? virtual[0].maxEventDays : 0
		});
	}
}

export default alt.createStore(HostPortalStore, "HostPortalStore");



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/HostPortal/HostPortalStore.js